import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
var _ = function _(t) {
    return t;
  },
  _t;
import mediaQueries from "../../util/mediaqueries";
import { NeutralColors } from "../../constants/colors";
import styled from 'styled-components';
var ARTICLE_COLUMN_WIDTH = 640;
var ARTICLE_SECTION_HORIZONTAL_PADDING = 24;
var ARTICLE_SECTION_WIDTH = ARTICLE_COLUMN_WIDTH + 2 * ARTICLE_SECTION_HORIZONTAL_PADDING;
var TEXT_COLOR_PRIMARY = NeutralColors.White;
export var RawHTMLSectionContainer = styled.div.withConfig({
  componentId: "sc-1e1ilbs-0"
})(["margin:0 auto;padding:", "px;max-width:", "px;*{font-size:18px;line-height:30px;}a{border-bottom:2px solid;border-color:", ";&:hover{transition:0.5s;background-color:", ";color:", ";}}img{max-width:100%;", "}"], ARTICLE_SECTION_HORIZONTAL_PADDING, ARTICLE_SECTION_WIDTH, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, TEXT_COLOR_PRIMARY, mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      max-width: ", "px;\n    "])), 0)), ARTICLE_COLUMN_WIDTH));